import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;

  > * {
    flex: 1;
    border-radius: 0;

    & ~ * {
      border-left: 0;
    }
    &:first-child {
      border-top-left-radius: ${props => props.theme.borderRadius.small};
      border-bottom-left-radius: ${props => props.theme.borderRadius.small};
    }
    &:last-child {
      border-top-right-radius: ${props => props.theme.borderRadius.small};
      border-bottom-right-radius: ${props => props.theme.borderRadius.small};
    }
  }
`

function SearchFormFieldGroup(props: PropsWithChildren) {
  const { children } = props

  return (
    <Container>
      {children}
    </Container>
  )
}

export default SearchFormFieldGroup
